<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
#app {
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    /* font-family: "SourceHanSerifSC-VF";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; */
    color: #2c3e50;
    margin: 0;
    padding: 0;
    background: #F9FAFE;
}

body {
    margin: 0;
    display: flex;
    flex-direction: column;
    text-align: center;
}

/*>=1024的设备屏幕*/
@media screen and (min-width: 1024px) {
    html {
        font-size: 16px;
        min-width: 972.8px;
    }
}

/*>=1100的设备屏幕*/
@media screen and (min-device-width: 1100px) {
    html {
        font-size: 17.18px;
        min-width: 1045px;
    }
}

/*>=1280的设备屏幕*/
@media screen and (min-device-width: 1280px) {
    html {
        font-size: 20px;
        min-width: 1216px;
    }
}

/*>=1366的设备屏幕*/
@media screen and (min-device-width: 1366px) {
    html {
        font-size: 21.34px;
        min-width: 1297.7px;
    }
}

/*>=1440的设备屏幕*/
@media screen and (min-device-width: 1440px) {
    html {
        font-size: 22.5px;
        min-width: 1368px;
    }
}

/*>=1680的设备屏幕*/
@media screen and (min-device-width: 1680px) {
    html {
        font-size: 26.25px;
        min-width: 1596px;
    }
}

/*>=1920的设备屏幕*/
@media screen and (min-device-width: 1920px) {
    html {
        font-size: 30px;
        min-width: 1824px;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue